import { useEffect, useState } from 'react';
import { Button, ProgressBar, Stack, Text } from 'shell/components';

const ProgressBarDemo = () => {
    const [progress, setProgress] = useState(0);
    const [isHidden, setIsHidden] = useState(true);
    const [progress2, setProgress2] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((current) => {
                if (current === 100) {
                    return 0;
                }
                const diff = Math.random() * 10;
                return Math.min(current + diff, 100);
            });
        }, 500);

        return () => {
            clearInterval(timer);
        };
    }, []);

    const onClickStart = () => {
        setIsHidden(false);
        setTimeout(() => {
            setProgress2(100);
        }, 5000);
    };

    const onClickReset = () => {
        setIsHidden(true);
        setProgress2(0);
    };

    const simulateProgress = {
        duration: 5,
        maxValue: 90,
    };

    return (
        <>
            <Text variant={'sh1'}>Progress</Text>
            <Stack spacing={8}>
                <Stack spacing={2}>
                    <Text>Simple progress bar</Text>
                    <ProgressBar value={progress} />
                </Stack>
                <Stack spacing={2}>
                    {!isHidden && <ProgressBar simulateProgress={simulateProgress} value={progress2} />}
                    <Text>
                        Simulate {simulateProgress.maxValue}% of progress over (roughly) {simulateProgress.duration}{' '}
                        seconds.
                    </Text>
                    <Stack direction={'row'} spacing={2}>
                        <Button size={'small'} onClick={onClickStart}>
                            Start
                        </Button>
                        <Button size={'small'} variant={'secondary'} onClick={onClickReset}>
                            Reset
                        </Button>
                    </Stack>
                </Stack>
            </Stack>
        </>
    );
};

export default ProgressBarDemo;
